module.exports = __webpack_public_path__ + "assets/img/pause.415f42f3.svg";